export default __webpack_public_path__ + "static/media/icon-rekava-white.22d1e11e.svg";